// const playBeep = () => {
//   try {
//     const audio = new Audio("/beep1.mp3");
//     audio.volume = 0.6;
//     const playPromise = audio.play();
//     if (playPromise && typeof playPromise.catch === "function") {
//       playPromise.catch((err) => {
//         console.log("Beep playback rejected:", err);
//       });
//     }
//   } catch (err) {
//     console.error("Beep sound error:", err);
//   }
// };

// export default playBeep;

// let isSoundOn = true; // global flag to control beep
// const isSoundOn = localStorage.getItem("isSoundOn") === "false" ? false : true;
let isSoundOn = JSON.parse(localStorage.getItem("isSoundOn") ?? "true");

export const setSoundOn = (value) => {
  isSoundOn = value;
};

const playBeep = () => {
  if (!isSoundOn) return; // exit if sound is off

  try {
    const audio = new Audio("/beep1.mp3");
    audio.volume = 0.6;
    const playPromise = audio.play();
    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch((err) => {
        console.log("Beep playback rejected:", err);
      });
    }
  } catch (err) {
    console.error("Beep sound error:", err);
  }
};

export default playBeep;
